'use strict';

// Polyfill promises
window.Promise = window.Promise || require('es6-promise').Promise;

var loaded = false;

/**
 * Google Maps API service
 * @type {Promise}
 */
function getMapsAPI() {
	if ( loaded === false ) {
		loadScript();
	}

	return new Promise(function gmapsApiPromise(resolve, reject) {
		var gmapApi;

		// Function gets called when Google Maps API has loaded
		window.initGoogleMaps = function initGoogleMaps() {
			gmapApi = google.maps;

			loaded = true;

			resolve(gmapApi);
		};
	});
};

// Inits the appending of the gmaps script
function loadScript() {
	var script = document.createElement('script');
	script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD_FKTPHezZ83BmvScUWOmNZNM3NMSgpgY&callback=window.initGoogleMaps';
	script.async = true;
	script.defer = true;
	document.body.appendChild(script);
}

// Utility function to get the maps API
module.exports = {
	getMapsAPI: getMapsAPI
};